import { connect } from 'react-redux';
import { RootState, Dispatch } from 'shared/state';
import { fetchSearchResults, selectSite } from 'shared/state/ducks/sites';
import SearchBarWidget from './SearchBarWidget';

interface SearchWidgetContainerProps {
  siteId: number;
}

const mapStateToProps = (
  state: RootState,
  ownProps: SearchWidgetContainerProps
) => ({
  searchResults: state.searchResults,
  site: selectSite(ownProps.siteId)(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchSearchResults: (query: string, site: Site) =>
    dispatch(fetchSearchResults(query, site)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SearchBarWidget);
